// The banner the receipts pages show while the last receipts backup was
// refused. The server says so on the list and detail answers (backupRefused);
// when backups are healthy it says nothing and nothing shows. It clears on its
// own after a backup passes.

const when = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return 'At a time not recorded';
  return `On ${d.toLocaleString('en-US', { timeZone: 'America/Chicago', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })} CT`;
};

export function bannerText(refused) {
  if (!refused) return null;
  const why = (refused.reasons || []).filter(Boolean);
  return {
    title: 'Receipts backup refused — new receipts are paused',
    body: `${when(refused.at)} the receipts backup failed its checks${why.length ? `: ${why.join('; ')}` : ''}. The last good backup was kept. New receipts are paused until this is fixed: emails wait in the receipts inbox. Existing receipts can still be viewed.`,
  };
}

export default function BackupBanner({ refused }) {
  const t = bannerText(refused);
  if (!t) return null;
  return (
    <div className="rc-backup-banner" role="alert">
      <strong>⚠ {t.title}</strong>
      <p>{t.body}</p>
    </div>
  );
}
